module.exports = __webpack_public_path__ + "static/media/azulpetroleo.8ff1ebff.png";